import Vue from "vue";

export function pageAllSysSensitiveApi(params, success, complete) {
    let url = "/admin/web/sysSensitive/pageAllSysSensitive";
    Vue.prototype.alexPost(url, params, success, null, complete);
}


export function insertSysSensitiveApi(params, success) {
    let url = "/admin/web/sysSensitive/insertSysSensitive";
    Vue.prototype.alexPost(url, params, success);
}

export function updateSysSensitiveApi(params, success) {
    let url = "/admin/web/sysSensitive/updateSysSensitive";
    Vue.prototype.alexPost(url, params, success);
}



export function deleteSysSensitiveApi(params, success) {
    let url = "/admin/web/sysSensitive/deleteSysSensitive";
    Vue.prototype.alexPost(url, params, success);
}


